/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_Target_Label_LbInputs */

const en_us2_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight you want to reach (lb)`)
};

const pt_br2_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso que você quer alcançar (lb)`)
};

const es_419_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso que quieres alcanzar (lb)`)
};

const pt_pt2_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso que queres alcançar (lb)`)
};

const fr_fr2_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge à atteindre (lb)`)
};

const de_de2_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgewicht (lb)`)
};

const it_it2_exercise_personal_goal_target_label_lb = /** @type {(inputs: Exercise_Personal_Goal_Target_Label_LbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso che vuoi raggiungere (lb)`)
};

/**
* | output |
* | --- |
* | "Weight you want to reach (lb)" |
*
* @param {Exercise_Personal_Goal_Target_Label_LbInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_target_label_lb = /** @type {((inputs?: Exercise_Personal_Goal_Target_Label_LbInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Target_Label_LbInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_target_label_lb(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_target_label_lb(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_target_label_lb(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_target_label_lb(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_target_label_lb(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_target_label_lb(inputs)
	return en_us2_exercise_personal_goal_target_label_lb(inputs)
});
export { exercise_personal_goal_target_label_lb as "exercise-personal.goal_target_label_lb" }